import { render } from "./AstroWuerfel.vue?vue&type=template&id=6ba1fb8c&scoped=true"
import script from "./AstroWuerfel.vue?vue&type=script&lang=js"
export * from "./AstroWuerfel.vue?vue&type=script&lang=js"

import "./AstroWuerfel.vue?vue&type=style&index=0&id=6ba1fb8c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba1fb8c"]])

export default __exports__